import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientStaffingPage from "@/pages/client/ClientStaffingPage";

export const Route = createFileRoute("/client/contracts/$contractId/staffing")({
  head: () => pageHead("Client · Contracts · Staffing", "AKIVA client · contracts · staffing portal.", "/client/contracts/$contractId/staffing", true),
  component: ClientStaffingPage,
});
